import {Component, OnInit} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {map} from "rxjs/operators";
import {Observable} from "rxjs";
import {OrderReviewChecklist} from "../../../../store/state/order-review-checklist.state";
import {getProcessTypeFor, getProcessTypeForStandard, Order, ProcessType, Product} from "../../../../store/state/order.state";
import {QuestionTranslatorFactoryService} from "../../../services/question-translator-factory.service";
import {GMTToLocalDateTime} from "../../../date-functions";
import {Question} from "../../../../store/state/checklist-common";

@Component({
    selector: 'review-checklist-document',
    templateUrl: './review-checklist-document.template.html',
    styleUrls: ['./review-checklist-document.style.scss'],
    standalone: false
})
export class ReviewChecklistDocumentComponent implements OnInit {

	checklist$: Observable<OrderReviewChecklist>;
	checklist: OrderReviewChecklist;
	order$: Observable<Order>;
	order: Order;

	constructor(private route: ActivatedRoute, private translatorFactory: QuestionTranslatorFactoryService) {

	}

	ngOnInit(): void {
		this.checklist$ = this.route.data.pipe(map(data => data['checklist']));
		this.checklist$.subscribe(checklist => this.checklist = checklist);
		this.order$ = this.route.data.pipe(map(data => data['order']));
		this.order$.subscribe(order => this.order = order);
	}

	get checklistCreationDate(): Date {
		return GMTToLocalDateTime(this.checklist.declineDate != null ? this.checklist.declineDate : this.checklist.acceptanceDate);
	}

	get processType(): string {
		switch (getProcessTypeFor(this.order)) {
			case ProcessType.INITIAL_CERTIFICATION:
				return 'Initial Certification';
			case ProcessType.RECERTIFICATION:
				return 'Renewal';
			case ProcessType.TRANSFER:
				return 'Transfer';
		}

		return null;
	}

	getProcessTypeForProduct(product: Product) {
		switch (getProcessTypeForStandard(product.standard)) {
			case ProcessType.INITIAL_CERTIFICATION:
				return 'initial';
			case ProcessType.RECERTIFICATION:
				return 'renewal';
			case ProcessType.TRANSFER:
				return 'transfer';
		}
	}

	get declineReason(): string {
		const numberOfDeclineEvents = this.order.declineInfo.declineEvents.length;
		return this.order.declineInfo.declineEvents[numberOfDeclineEvents - 1].reason;
	}

	getQuestionExplanation(question: Question): string {
		return this.translatorFactory.getTranslator(getProcessTypeFor(this.order)).getExplanation(question);
	}

	toAnswer(value: boolean): string {
		if (value == null) {
			return 'NOT PROVIDED';
		}
		return value ? 'YES' : 'NO';
	}

	get phoneNumber(): string {
		return this.order.contactPerson.phoneNumber.replace("+1", "+1 ");
	}

}
